<template>
	<v-app v-resize="onResize">
		<v-content>
			<div class="holder" id="holderElem">

				<!-- Title Section -->
				<div class="titleDiv" id="detailMenu" @click.stop="toggleTitle()">
					<v-icon small dark  class="toggleIcon">{{ showTitle ? 'chevron_left' : 'chevron_right' }}</v-icon>

					<div @click.stop="" v-show="showTitle" class="titleRow">
						
						<v-card dark color="transparent" class="elevation-0 rowCard">
							<v-img 
								class="title-image pt-2" 
								src="https://images.squarespace-cdn.com/content/v1/532a1706e4b0d901d03d02af/1550112197670-PD5JWCDE30DEX30YM980/ke17ZwdGBToddI8pDm48kLkXF2pIyv_F2eUT9F60jBl7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0iyqMbMesKd95J-X4EagrgU9L3Sa3U8cogeb0tjXbfawd0urKshkc5MgdBeJmALQKw/img-3.jpg"
								gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
							>
								<v-container fill-height fluid class="pr-0">
									<v-layout align-center justify-center>
										<v-flex xs12 flexbox>
											<h1 class="title-text font-weight-light font-medium pr-4">Silver Oaks Chateau</h1>
											<v-card-actions class="pb-0">
												<v-spacer></v-spacer>
												<v-btn small id="clubButton" flat @click="toggleDetails()">
													Gallery
													<v-icon right dark>{{ !showDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
												</v-btn>
												<v-btn small class="" id="signUpButton" flat @click="toggleForm()">
													Book Now
													<v-icon right dark>{{ !showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
												</v-btn>
											</v-card-actions>
										</v-flex>
									</v-layout>
								</v-container>
							</v-img>

								<!-- <v-card-actions class="pb-0">
									<v-spacer></v-spacer>
									<v-btn small id="clubButton" flat @click="toggleDetails()">
										Gallery
										<v-icon right dark>{{ !showDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
									</v-btn>
									<v-btn small  :color="globalColor" class="" id="signUpButton" flat @click="toggleForm()">
										Book Now
										<v-icon right dark>{{ !showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
									</v-btn>
								</v-card-actions> -->

								<v-expand-transition>
									<!-- <v-card-text v-show="showForm" :class="mobile ? 'clubGridMobile pa-0' : 'clubGrid pa-0'">
										<iframe width="100%" height="100%"
											src="http://www.silveroakschateau.com/"
											frameborder="0">
										</iframe>
									</v-card-text> -->
								</v-expand-transition>

								<v-expand-transition>
									<v-card-text v-show="showDetails" :class="mobile ? 'clubGridMobile pa-0' : 'clubGrid pa-0'">
											<template v-if="selectedGallery === null && currentZone">
												
												<v-container grid-list-xl fluid class="gallery-container pt-1">
													<h2 class="title-text font-medium font-weight-light mt-2">{{ currentZone.label }}</h2>
													<v-layout row wrap fill-height justify-center>
														
														<v-flex
															v-for="(gallery, i) in filteredGalleries"
															:key="i"
															xs12
															md4
															d-flex
															align-center 
															justify-center
														>
															<v-card flat tile class="d-flex gallery-card" @click="selectGallery(gallery)">
																
																<v-img
																	:src="require(`./assets/images/grand-hall/${gallery.images[0]}.jpg`)"
																	:lazy-src="require(`./assets/images/grand-hall/${gallery.images[0]}.jpg`)"
																	aspect-ratio="1"
																	gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
																>
																	<template v-slot:placeholder>
																		<v-layout
																		fill-height
																		align-center
																		justify-center
																		ma-0
																		>
																		<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
																		</v-layout>
																	</template>
																	<v-container fill-height fluid>
																		<v-layout align-center justify-center>
																			<v-flex xs12 flexbox>
																				<span class="headline">{{ gallery.label }}</span>
																			</v-flex>
																		</v-layout>
																	</v-container>
																</v-img>
															</v-card>
														</v-flex>
													</v-layout>
												</v-container>
											</template>
											<template v-else-if="selectedGallery">
												<v-container grid-list-lg fluid class="gallery-container pt-1">
													<v-btn flat small block @click="clearGallery()">
														<v-icon small class="mr-1">arrow_back</v-icon>
														back
													</v-btn>
													<v-layout row wrap>
														<v-flex
															v-for="(video, i) in selectedGallery.videos"
															:key="i"
															xs12
															md4
															d-flex
														>
															<v-card flat tile class="d-flex gallery-card-box" @click="loadVideo(video.source)">
																
																<v-img
																:src="require(`./assets/images/grand-hall/${video.thumbnail}.jpg`)"
																:lazy-src="require(`./assets/images/grand-hall/${video.thumbnail}.jpg`)"
																aspect-ratio="1"
																gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
																>
																	<v-container fill-height fluid>
																		<v-layout align-center justify-center>
																			<v-flex xs12 flexbox>
																				<span class="headline">Play Video</span><br>
																				<v-icon large>play_circle_outline</v-icon>
																			</v-flex>
																		</v-layout>
																	</v-container>
																</v-img>
															</v-card>
														</v-flex>
														<v-flex
															v-for="(image, i) in selectedGallery.images"
															:key="i"
															xs12
															md4
															d-flex
														>
															<v-card flat tile class="d-flex gallery-card-box">
																
																<v-img
																:src="require(`./assets/images/grand-hall/${image}.jpg`)"
																:lazy-src="require(`./assets/images/grand-hall/${image}.jpg`)"
																aspect-ratio="1"
																
																>
																	<template v-slot:placeholder>
																		<v-layout
																			fill-height
																			align-center
																			justify-center
																			ma-0
																		>
																			<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
																		</v-layout>
																	</template>
																</v-img>
															</v-card>
														</v-flex>
													</v-layout>
												</v-container>
											</template>						
									</v-card-text>
								</v-expand-transition>

						</v-card>
						
					</div>
					
				</div>

				<!-- Matterport iFrame -->
				<div id="iframeHolder">
					<iframe width="100%" height="100%"
						src="https://my.matterport.com/show/?m=dJ525xBtLvo&play=1&hr=0&title=0&vr=0&hl=1&brand=0"
						frameborder="0"
						id="showcase_iframe">
					</iframe>
				</div>
				
				<!-- Right side buttons -->
				<div class="rightButtons">
					<v-btn v-if="mode === 'edit'" icon flat small @click="zoneSweepDialog = true" dark>
						<v-icon color="white">library_add</v-icon>
					</v-btn>

					<v-btn v-if="mode === 'edit'" icon flat small @click="dataDialog = true" dark>
						<v-icon color="white">add_circle_outline</v-icon>
					</v-btn>

					<v-btn icon flat small  @click="helpTour()" class="helpButton">
						<v-icon color="white">help_outline</v-icon>
					</v-btn>

					<!-- <v-btn dark flat icon small @click="startVR()" class="vrButton">
						VR
					</v-btn> -->
					
					<v-btn v-if="!isMobile" icon flat small  @click="toggleFullscreen()" class="fullscreenButton">
						<v-icon color="white">{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
					</v-btn>

					<!-- <v-btn icon flat small  @click="toggleFullscreen()" class="fullscreenButton">
						<v-icon color="white">{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
					</v-btn> -->
				</div>
				
				<!-- Sign Up Form -->
				<div v-if="false" id="formDiv" class="form-5">
					<v-card class="form-card-1" dark>
						<v-card-title>
							<span class="headline">Get a week on us!</span>
							<v-spacer></v-spacer>
							<v-btn icon flat @click="showForm = false">
								<v-icon>close</v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
							<v-flex xs12>
								<v-text-field label="Your First Name*" required></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
								label="Your Last Name*"
								required
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field label="Your Email Address*" required></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field label="Your Phone Number*" required></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-autocomplete
								:items="['Skiing', 'Ice hockey', 'Soccer', 'Basketball', 'Hockey', 'Reading', 'Writing', 'Coding', 'Basejump']"
								label="Select Club"
								multiple
								></v-autocomplete>
							</v-flex>
							<v-btn block color="blue" @click="getScreenPos()" dark>Start your FREE week!</v-btn>

							</v-layout>
						</v-container>
						</v-card-text>
					</v-card>
				</div>

				<!-- Navigation Drawer Toggle Button -->
				<v-btn
				fixed
				dark
				small
				fab
				top
				right
				:color="globalColor"
				@click="toggleDrawer()"
				style="z-index: 1000;"
				id="drawerButton"
				>
				<v-icon>{{ drawer ? 'chevron_right' : 'chevron_left' }}</v-icon>
				</v-btn>

				<!-- Right Nav Drawer -->
				<v-navigation-drawer
						class="navDrawer"
						dark
						absolute
						right
						v-model="drawer"
						v-show="drawer"
						floating
						hide-overlay
						width="280"
					>
						<v-toolbar color="transparent elevation-0 mb-2">
							<v-toolbar-title>Where to next?</v-toolbar-title>
						</v-toolbar>
						
						<v-list class="transparent" subheader >

							<template>				
								<v-list-tile
									v-for="item in items"
									:key="item.title"
									@click="navigate(item)"
								>
									<v-list-tile-content>
										<v-list-tile-title>{{ item.title }}</v-list-tile-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					
					</v-navigation-drawer>


				<!-- Navigation Menu-->
				<div v-if="!showForm" v-show="show" id="containerDiv" class="bar">
					<v-card class="form-card" dark>
						<v-card-title class="pb-1">
							<span class="title">Where To Next ?</span>
							<v-spacer></v-spacer>
							<v-icon @click="show = false">
								close
							</v-icon>
						</v-card-title>
						
						<v-container grid-list-md class="pt-1">
							<v-layout wrap>
								<v-flex xs12 v-for="(item, i) in items" :key="i">
									<v-btn block small color="blue" @click="moveToSpinning()" dark>{{item.title}}</v-btn>
								</v-flex>
								<v-flex xs12>
									<v-btn block small color="blue" @click="showForm = true" dark>Show Form</v-btn>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card>
				</div>
				
			</div>
		</v-content>

		<!-- Navigation Data Dialog -->
		<v-dialog v-model="dataDialog" persistent :transition="false" max-width="400px">
			<v-card>
				<v-toolbar dark color="primary">
					<v-btn :ripple="false" icon dark @click="dataDialog = false">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title>Add Data</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn :ripple="false" flat dark @click="addData()">save</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-container style="text-align: center;">

					<v-text-field label="Title" v-model="title"></v-text-field>
					<v-text-field label="Floor" type="number" v-model="floor"></v-text-field>

				</v-container>
			</v-card>
		</v-dialog>

		<!-- Zone Sweep Data Dialog -->
		<v-dialog v-model="zoneSweepDialog" persistent :transition="false" max-width="400px">
			<v-card>
				<v-toolbar dark color="primary">
					<v-btn :ripple="false" icon dark @click="zoneSweepDialog = false">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title>Add Zone Sweep</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn :ripple="false" flat dark @click="addZoneSweep()">save</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-container style="text-align: center;">

					<v-select :items="zones" item-text="label" label="Zone" v-model="selectedZone" return-object></v-select>

				</v-container>
			</v-card>
		</v-dialog>

		<!-- Video Dialog -->
		<v-dialog v-model="videoDialog" persistent :transition="false" max-width="600px">
			<v-card>
				<v-toolbar dense dark :color="globalColor">
					<v-btn :ripple="false" icon dark @click="stopVideo()">
						<v-icon>close</v-icon>
					</v-btn>
					<!-- <v-toolbar-title>Top Billing Feature</v-toolbar-title> -->
					<v-spacer></v-spacer>
				</v-toolbar>
				<!-- <iframe id="player" width="100%" height="320" src="" allowscriptaccess="always" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
				<iframe id="player" src="" width="100%" height="350" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
			</v-card>
		</v-dialog>

		<!-- Aerial Image Dialog -->
		<!-- <v-dialog v-model="carouselDialog" persistent :transition="false" max-width="800px">
			<v-card>
				<v-toolbar dark color="primary">
					<v-btn :ripple="false" icon dark @click="closeImages()">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title>Aerial Photos</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>
				<v-carousel :cycle="false">
					<v-carousel-item
						v-for="(item,i) in images"
						:key="i"
						:src="'http://sothebys.vrdynamics.africa/cornwall-hill-estate/images/' + item.src"
					></v-carousel-item>
				</v-carousel>
			</v-card>
		</v-dialog> -->
		
		
	</v-app>
</template>

<script>
	import { setTimeout } from 'timers';
	import Trip from 'trip.js'

	export default {
		data() {
			return {
				mpSdk: null,
				globalColor: '#7b9169',
				mode: 'prod',
				show: false,
				isMobile: false,
				showTitle: true,
				dataDialog: false,
				zoneSweepDialog: false,
				drawer: false,
				showForm: false,
				slider: 15,
				showDetails: false,
				mouseEventActive: false,
				skipZoneCheck: false,
				title: '',
				floor: 0,
				clientX: 0,
				clientY: 0,
				fullscreen: false,
				videoDialog: false,
				videoTag: null,
				carouselDialog: false,
				selectedZone: null,
				img: '',
				mattertags: null,
				items: [
					{"title":"Grand Hall","floor":0,"sweepId":"354af980cfda40ccbd0b91a0f370721e","rotation":{"x":0.42973885598718814,"y":74.57939101983513}},
					{"title":"Grand Hall Balcony","floor":0,"sweepId":"9d3ac8f9e114482182503951f0ea0256","rotation":{"x":-16.300100751749827,"y":-62.06482832618666}},
					{"title":"Bride's Room","floor":0,"sweepId":"d305bb1a1a3a4398add68ef25ca6fe22","rotation":{"x":-11.07935214017801,"y":-52.42760508901261}},
					{"title":"Groom's Room","floor":0,"sweepId":"65de6c8f50b24a03a0620f885b4a25ae","rotation":{"x":-13.023742741434084,"y":53.360025457200805}},
					{"title":"Lower Foyer","floor":0,"sweepId":"26c4f5ff463c45798cff22ff049e0dcb","rotation":{"x":-6.731429869216429,"y":-59.59551719388284}}
				],
				selectedGallery: null,
				currentZone: null,
				galleries: [
					{
						id: 1,
						zoneId: 1,
						label: 'White Wedding',
						images: [
							1,4,5,6,7,8,13,14,15,16,17,18,19,21,22,23,27,28,33,34,35,36,37,39
						],
						videos: [
							{ 
								source: 'https://player.vimeo.com/video/191006733', 
								thumbnail: 8
							},
							/* {
								source: 'https://player.vimeo.com/video/250227518?title=0&byline=0&portrait=0', 
								thumbnail: 16
							} */
						]
					},
					{
						id: 2,
						zoneId: 1,
						label: 'Traditional Wedding',
						images: [
							9,10,11,12,20,29,31,32
						],
						videos: [
							/* {
								source: 'https://player.vimeo.com/video/241148908?title=0&amp;byline=0&amp;portrait=0', 
								thumbnail: 3
							}, */
							
						]
					},
					{
						id: 3,
						zoneId: 1,
						label: 'Conference',
						images: [
							2,3,32,34,26
						]
					},
					{
						id: 4,
						zoneId: 2,
						label: 'White Wedding',
						images: [
							101,102,103,
						]
					},
					{
						id: 5,
						zoneId: 2,
						label: 'Traditional Wedding',
						images: [
							100
						]
					},
					{
						id: 6,
						zoneId: 2,
						label: 'Conference',
						images: [
							104
						]
					}
				],
				zones: [
					{
						id: 1,
						label: 'Grand Hall',
						isDefault: true
					},
					{
						id: 2,
						label: 'Grooms Room'
					},
				],
				zoneSweeps: [
					{"sweepId":"1ae914da16a14ba8b5db0a8e1f3746a3","zoneId":1},{"sweepId":"0fe978a8ea7e40f2aa437e65ef968ed7","zoneId":1},{"sweepId":"9b806b9f5c044958b1df15b8b2873481","zoneId":1},{"sweepId":"1df55b4b5c344bfd8ace8e04782744d8","zoneId":1},{"sweepId":"3715c141aec447249556310b85abbcf6","zoneId":1},{"sweepId":"8a83c32c3822471190acf29599ccc70c","zoneId":1},{"sweepId":"5ec4532a6d4f426589f190ed3f7f600b","zoneId":1},{"sweepId":"92ff3849c86e406da525d29d755dfc9c","zoneId":1},{"sweepId":"ef120e3a9e60438daf9c724dc057a6a9","zoneId":1},{"sweepId":"354af980cfda40ccbd0b91a0f370721e","zoneId":1},{"sweepId":"80800030876d4cef90addcd5c84bd2d4","zoneId":1},{"sweepId":"b386c72a34724e5e9b35d9daa730c6b8","zoneId":1},{"sweepId":"fc1edb90ecbe47748182af679a3c1a1d","zoneId":1},{"sweepId":"c574ca2a635b428ea3b6550e6d1c5802","zoneId":1},{"sweepId":"eca23adce4b44f638e1bf22c7fba9bdb","zoneId":1},{"sweepId":"8a987c9c5d17467db9d59bff83e99f22","zoneId":1},{"sweepId":"615a3c96b0204e5ab81aeabbe143c877","zoneId":1},{"sweepId":"b717d54177ef4c5c980e085272970cac","zoneId":1},{"sweepId":"44f5c718147946e09322f23069b6f4d0","zoneId":1},{"sweepId":"be6ea92344a54775bafdd8e51d33f2b2","zoneId":1},{"sweepId":"8ae43c8d17dd4fb7be44fa6405f6a160","zoneId":1},{"sweepId":"bcd2e3ec52824d61bf07fa249ddba14e","zoneId":1},{"sweepId":"903388ca664242b78a16e7beb6b5e84b","zoneId":1},{"sweepId":"4021f1d33e164d739dee7ce55ddefc15","zoneId":1},{"sweepId":"615a3c96b0204e5ab81aeabbe143c877","zoneId":1},{"sweepId":"8a987c9c5d17467db9d59bff83e99f22","zoneId":1},{"sweepId":"2fc09053414348e59443a65198e1aa52","zoneId":1},{"sweepId":"c067f233598b40ebb0b8b3498d09552f","zoneId":1},{"sweepId":"dd3173f2f0a249a4ad76ad7f81f7b739","zoneId":1},{"sweepId":"5f241dfb903c4bdc967e4313757cfac0","zoneId":1},{"sweepId":"304fc3c82a5f4a0f8bfc84b4a158a530","zoneId":1},{"sweepId":"b66ab2a713ff4325bf6fa1e13716bf78","zoneId":1},{"sweepId":"1b24454de69e470790d4975c6cb0fc21","zoneId":1},{"sweepId":"0671ee3971c840da9414ea9ef6325dfc","zoneId":1},{"sweepId":"f9668690051943fc814d2bace64267d4","zoneId":1},{"sweepId":"744f4e35057a45c1aadef774587a0a99","zoneId":1},{"sweepId":"97d49866450345acbf7116e0d972a609","zoneId":1},{"sweepId":"bcde798a6c794051bfdf048774d4bbdd","zoneId":1},{"sweepId":"92121f118e1e4737b5756ae5a21e49d9","zoneId":1},{"sweepId":"3fb4586096a14aa886d92b913d6123ee","zoneId":1},{"sweepId":"67a23c7a85244c65a507db3a7e258e35","zoneId":1},{"sweepId":"89d848a54c834b5f96a28c7e1db25627","zoneId":1},{"sweepId":"8a346eb98244477c92f163b28c6259ee","zoneId":1},{"sweepId":"9d3ac8f9e114482182503951f0ea0256","zoneId":1},{"sweepId":"33b6c705359046d3822d7b812cee9da0","zoneId":1},{"sweepId":"64d060e954ee4fb0be711349fe393a18","zoneId":1},{"sweepId":"13d1e395970e473db61b59aa8c399b03","zoneId":1},{"sweepId":"9cfdd4e2b03a493d93e8485945a3e9fc","zoneId":1},{"sweepId":"c72127da34a748d285ab43b77d7e69c8","zoneId":1},{"sweepId":"cfd7d48b1e2843d488c3a698ef97d103","zoneId":1},{"sweepId":"0566a6fae857445590c79a95a9db85d5","zoneId":1},{"sweepId":"844303d49f3a4c678d8346a8f66cd8dc","zoneId":1},{"sweepId":"27126b3c967144ca958636e692b827ee","zoneId":1},{"sweepId":"ce798347a9be44649377d5587df933eb","zoneId":1},{"sweepId":"2b00522d482a4d71bfbf9cba5dda84a8","zoneId":1},{"sweepId":"a894dfd1e4f44b8394cee975e6860166","zoneId":1},{"sweepId":"65c9bb8b76f34d329488363d6ab49564","zoneId":1},{"sweepId":"cafc2e3c1b004df988ca30957dff3770","zoneId":1},
					{"sweepId":"12f2f7ac9d454c4c82387f72a201585c","zoneId":2},{"sweepId":"34c1c932f0df4c7cb9968a9c3aa717dd","zoneId":2},{"sweepId":"65de6c8f50b24a03a0620f885b4a25ae","zoneId":2},{"sweepId":"153731e3868645608c4b3c5d376bca51","zoneId":2},{"sweepId":"d70d7c79d45a41268b0fc8d8b50c5eb9","zoneId":2},{"sweepId":"ec0bfc822dc14d4391561811c0bfc0c4","zoneId":2},{"sweepId":"7af6c9ebbbd64cc8887aa154bc95f886","zoneId":2},{"sweepId":"0896e3f645544bceb77f1fdb8bb21079","zoneId":2},{"sweepId":"7e9959ebcf534d40aa4e9284c246a4b4","zoneId":2}
				]

			}
		},

		methods: {

			nav() {
				this.$router.push({name: 'about'})
			},

			onResize () {
				// console.log('resized');
				// let wrapper = document.querySelector('.application--wrap');
				// wrapper.style.minHeight = '100vh !important';

				// setTimeout(() => {
				// 	wrapper.style.minHeight = '-webkit-fill-available !important';
				// 	this.$forceUpdate();
				// }, 200)
			},

			addData() {
				this.getCurrentData().then((pose) => {
					let obj = {
						title: this.title,
						floor: this.floor,
						sweepId: pose.sweep,
						rotation: pose.rotation
					}

					this.items.push(obj);
					this.dataDialog = false;
					console.log('Item List', JSON.stringify(this.items));
				});
			},

			addZoneSweep() {
				this.getCurrentData().then((pose) => {
					let obj = {
						sweepId: pose.sweep,
						zoneId: this.selectedZone.id
					}

					this.zoneSweeps.push(obj);
					this.zoneSweepDialog = false;
					console.log('zoneSweeps List', JSON.stringify(this.zoneSweeps));
				});
			},

			checkCurrentZone(sweep) {
				if(this.zoneSweeps.length > 0) {
					const value = this.zoneSweeps.find((x) => x.sweepId === sweep);
					if (value) {
						this.currentZone = this.zones.find((x) => x.id === value.zoneId);
					} else {
						this.currentZone = this.zones.find((x) => x.isDefault);
					}
				}
			},

			clearGallery() {
				this.selectedGallery = null;
			},

			selectGallery(gallery) {
				this.selectedGallery = gallery;
			},

			helpTour() {
				var vm = this;
				const tripToHighlight = new Trip([
					{ sel : $('#drawerButton'), content : "Click to show navigation menu.", expose : true, position : "w", animation: 'rotateInUpRight'},
					{ sel : $('#detailMenu'), content : "Click to show detail menu", expose : true, position : "e", animation: 'rotateInUpRight' },
					{ sel : $('#clubButton'), content : "Click to view gallery", expose : false, position : "s", animation: 'rotateInUpRight' },
					{ sel : $('#signUpButton'), content : "Click to view contact info", expose : false, position : "s", animation: 'rotateInUpRight' },
				], {
					delay : 3000,
					tripTheme: 'white',
					onTripChange : function(i, tripData) {
						switch(i) {
							case 0:
								setTimeout(() => {
									vm.drawer = true;
								},700)
								vm.showTitle = false;
								vm.showForm = false;
								break;
							case 1:
								vm.drawer = false;
								setTimeout(() => {
									vm.showTitle = true;
								},700)
								break;
							case 2:
								
								setTimeout(() => {
									vm.showDetails = true;
								},700)
								break;
							case 3:
								vm.showDetails = false;
								setTimeout(() => {
									vm.showForm = true;
								},700)
								setTimeout(() => {
									vm.showForm = false;
								},3000)
								break;
						}
						
					}
				});

				tripToHighlight.start();

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'help',
					eventAction: 'start',
					eventLabel: `help tour started`
				});
			},

			gotoWebsite() {
				window.open('http://vrdynamics.africa')
			},

			toggleDetails() {
				this.showForm = false;
				this.showDetails = !this.showDetails;

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'features',
					eventAction: this.showDetails ? 'show' : 'hide',
				});
			},

			toggleForm() {
				this.showDetails = false;
				this.showForm = !this.showForm;

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'contact',
					eventAction: this.showForm ? 'show' : 'hide',
				});
			},

			toggleTitle() {
				this.showTitle = !this.showTitle

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'title',
					eventAction: this.showTitle ? 'open' : 'close'
				});
			},

			toggleDrawer() {
				this.drawer = !this.drawer

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'navigate',
					eventAction: this.drawer ? 'open' : 'close'
				});
			},

			toggleNumbers() {
				this.$nextTick().then(() => {
					setTimeout(() => {
						if(this.$refs.numberExpansionPanel.open[0]) {
							this.analytics('send', {
								hitType: 'event',
								eventCategory: 'numbers',
								eventAction: 'open'
							});
						}
					}, 500);
				});
			},

			getScreenPos() {
				
				console.log('screenPos', this.mpSdk.Renderer.getScreenPosition())
				this.mpSdk.Renderer.getScreenPosition().then((pos) => {
					console.log('renderer.getScreenPosition', pos);
				})
				.catch((error) => {
					console.log('Error.renderer.getScreenPosition', error);
				})

				this.mpSdk.Renderer.getWorldPositionData().then((test) => {
					console.log('renderer.getWorlPositionData', test);
				})
				.catch((error) => {
					console.log('Error.renderer.getWorlPositionData', error);
				})

				this.mpSdk.Model.getData().then((data) => {
					console.log('Model.getData', data);
				})
				.catch((error) => {
					console.log('Error.Model.getData', error);
				})

				this.mpSdk.Model.getData().then((data) => {
					console.log('Model.getDetails', data);
				})
				.catch((error) => {
					console.log('Error.Model.getDetails', error);
				})

				this.mpSdk.Mattertag.getDiscCoordinates().then((data) => {
					console.log('Mattertag.getDiscCoordinates', data);
				})
				.catch((error) => {
					console.log('Error.Mattertag.getDiscCoordinates', error);
				})

				console.log('this.mpSdk', this.mpSdk)
			},

			showcaseLoader() {
				return new Promise((resolve, reject) => {
					try {
						var showcase = window.SHOWCASE_SDK.connect(
							document.getElementById('showcase_iframe'),
							'2fd85e7ae825430e9ad4958ebfbfdda7', // SDK Key.
							'3.0' // SDK version
						)
						.then(function(mpSdk) {
							// Model.Event.MODEL_LOADED
							resolve(mpSdk);
						})
						.catch(function(error) {
							reject(error)
						})
					}
					catch (e) {
						reject(error)
					}
				});
			},

			takeScreenshot() {
				const resolution = {
					width: 1920,
					height: 1080
				};

				// const resolution = {
				// 	width: 4096,
				// 	height: 4096
				// };

				const visibility = {
					mattertags: false,
					sweeps: false
				};

				this.mpSdk.Renderer.takeScreenShot(resolution, visibility)
				.then(function (screenShotUrl) {
					// set src of an img element
					var image = new Image();
					image.src = screenShotUrl;

					//window.open(image.src.replace(/^data:image\/[^;]+/, 'data:application/octet-stream'));
					const w = window.open('');
					w.document.write(image.outerHTML);
				});
			},

			getCurrentData() {
				return new Promise((resolve, reject) => {
					console.log('mpSdk ', this.mpSdk);

					// this.mpSdk.Renderer.getScreenPosition(worldPosition).then((result) => {
					// 	if(result !== null) {
					// 		console.log('x: ', result.x);
					// 		console.log('y: ', result.y);
					// 	}
					// });

					// this.mpSdk.Renderer.getScreenPosition().then((res) => {
					// 	console.log('res', res);
					// })

					this.mpSdk.Camera.getPose()
					.then(function(pose){
						console.log('Pose ', pose);
						console.log('Current position is ', pose.position);
						console.log('Rotation angle is ', pose.rotation);
						console.log('Sweep UUID is ', pose.sweep);
						console.log('View mode is ', pose.mode);
						resolve(pose)
					});
				});
			},

			start() {
				
				const vm = this

				this.showcaseLoader()
					.then(function(mpSdk){
						console.log('mpSdk',mpSdk)
						vm.mpSdk = mpSdk;

						/* mpSdk.on(mpSdk.Camera.Event.MOVE, function(pose) {
							vm.shouldShow(pose);
							ga('send', {
								hitType: 'event',
								eventCategory: 'camera',
								eventAction: 'move',
								eventLabel: item.title
							});
						}.bind(vm)); */

						vm.mpSdk.Model.getData().then((data) => {
							console.log('ModelData', data);
						})

						mpSdk.on(mpSdk.Sweep.Event.ENTER, function(sweep) {

							if(!this.skipZoneCheck) {
								this.checkCurrentZone(sweep);
							} else {
								this.skipZoneCheck = false;
							}

							this.analytics('send', {
								hitType: 'event',
								eventCategory: 'sweep',
								eventAction: 'enter',
								eventLabel: sweep
							});
						}.bind(vm));

						vm.mpSdk.Mattertag.getData()
						.then((data) => {
							vm.mattertags = data;
						})
						.catch((error) => {
							console.log('Mattertag.Error', error);
						})

						mpSdk.on(mpSdk.Mattertag.Event.CLICK, function(tagSID) {
							let tagDetails = vm.mattertags.filter((x) => x.sid === tagSID)[0];
							
							this.analytics('send', {
								hitType: 'event',
								eventCategory: 'mattertags',
								eventAction: 'click',
								eventLabel: `${tagDetails.sid}_${tagDetails.label}`
							});
						}.bind(vm));

						mpSdk.on(mpSdk.Mattertag.Event.HOVER, function(tagSID) {
							let tagDetails = vm.mattertags.filter((x) => x.sid === tagSID)[0];
							
							this.analytics('send', {
								hitType: 'event',
								eventCategory: 'mattertags',
								eventAction: 'hover',
								eventLabel: `${tagDetails.sid}_${tagDetails.label}`
							});
						}.bind(vm));

						/* mpSdk.on(mpSdk.Mattertag.Event.HOVER, function(event) {
							console.log('hover', event)

							// var iframe = document.getElementById("showcase_iframe").style.pointerEvents = 'none';

							// setTimeout(function() {
							// 	document.getElementById("showcase_iframe").style.pointerEvents = 'auto';
							// }, 10)
							

							vm.mpSdk.Mattertag.getData(event).then((data) => {
								console.log('Mattertag.getData', data);
								const coords = data.filter((x) => x.sid === event)[0];
								console.log('coords', coords.anchorPosition)

								this.mpSdk.Renderer.getScreenPosition(coords.anchorPosition).then((result) => {
									if(result !== null) {
										console.log('x: ', result.x);
										console.log('y: ', result.y);
										vm.shouldShow(true, result);
									}
								});

								
							})

							setTimeout(() => {
								vm.mpSdk.Mattertag.closeBillboards().then((data) => {
								console.log('Mattertag.closeBillboards', data);
								})
								.catch((error) => {
									console.log('Error', error);
								})
							},100)
							

							// vm.mpSdk.Mattertag.getDiscCoordinates(event).then((data) => {
							// 	console.log('Mattertag.getDiscCoordinates', data);
							// })
							// .catch((error) => {
							// 	console.log('Error', error);
							// })

							vm.shouldShow(true);

						}.bind(vm)); */

						// vm.mpSdk.Settings.get().then((settings) => {
						// 	console.log('settings', settings)
						// })

						// vm.mpSdk.Tour.getData().then((data) => {
						// 		console.log('Tour.getData', data);
						// });
					});

			},

			shouldShow(currentPose, coords) {
				// console.log('currentPos', currentPose);
				// console.log('currentPos', currentPose.position.x.toFixed(1));
				// console.log('currentPos', currentPose.position.y.toFixed(1));
				// console.log('currentPos', currentPose.position.z.toFixed(1));
				// console.log('currentPos', currentPose.rotation.x.toFixed(1));
				// console.log('currentPos', currentPose.rotation.y.toFixed(1));

				if (currentPose === true) {
					// setTimeout(() => {
					// 	let elem = document.getElementById('containerDiv');
					// 	let holder = document.getElementById('holderElem');
					// 	elem.style.top = (this.clientY - holder.getBoundingClientRect().top) + 'px' ;
					// 	elem.style.left = this.clientX + 'px';
					// 	this.show = true;
						
					// },100)

					setTimeout(() => {
						let elem = document.getElementById('containerDiv');
						let holder = document.getElementById('holderElem');
						elem.style.top = (coords.y - holder.getBoundingClientRect().top) + 'px' ;
						elem.style.left = coords.x + 'px';
						this.show = true;
						
					},100)
					
					return;
				}

				if(
					currentPose.position.x.toFixed(1) >= -4.3 &&
					currentPose.position.x.toFixed(1) <= -3.5 &&
					currentPose.position.y.toFixed(1) <= 2.0 &&
					currentPose.position.y.toFixed(1) >= 1.4 &&
					currentPose.position.z.toFixed(1) >= -1 &&
					currentPose.position.z.toFixed(1) <= 0 &&
					currentPose.rotation.x.toFixed(1) >= -10.2 &&
					currentPose.rotation.x.toFixed(1) <= -1 &&
					currentPose.rotation.y.toFixed(1) <= 190 &&
					currentPose.rotation.y.toFixed(1) >= 100 
				) {
					this.show = true;
				} else {
					this.show = false;
				}
			},

			navigate(item) {
				this.skipZoneCheck = true;
				this.moveToSweep(item);
			},

			moveToSweep(item, floorName) {
				const vm = this
				
				this.mpSdk.Sweep.moveTo(item.sweepId, {
					rotation: {x: item.rotation.x, y: item.rotation.y},
					transition: vm.mpSdk.Sweep.Transition.FLY
				}, vm)


				this.checkCurrentZone(item.sweepId);

				// this.analytics('send', {
				// 	hitType: 'event',
				// 	eventCategory: 'navigate',
				// 	eventAction: 'move-to',
				// 	eventLabel: `${item.sweepId}_${floorName}-${item.title}`
				// });

				this.drawer = false;
			},

			toggleFullscreen() {
				const doc = window.document;
				const docElement = doc.documentElement;
				const requestFullScreen = docElement.requestFullscreen || docElement.mozRequestFullScreen || docElement.webkitRequestFullScreen || docElement.msRequestFullscreen;
				const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

				if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
					requestFullScreen.call(docElement);
					this.fullscreen = true;

					this.analytics('send', {
						hitType: 'event',
						eventCategory: 'fullscreen',
						eventAction: 'open',
					});
				} else {
					cancelFullScreen.call(doc);
					this.fullscreen = false;

					this.analytics('send', {
						hitType: 'event',
						eventCategory: 'fullscreen',
						eventAction: 'close',
					});
				}
			},

			startVR() {
				window.open('https://my.matterport.com/vr/show/?m=peUB6Pooapf', '_blank');
				// if(navigator.getVRDisplays) {
				// 	console.log('here', navigator.getVRDisplays)
				// 	this.mpSdk.VR.presentVr();
				// } else {
				// 	window.open('https://my.matterport.com/vr/show/?m=peUB6Pooapf', '_blank');
				// }	
			},

			loadVideo(source) {
				let player = document.querySelector('#player');
				player.src = source;
				setTimeout(() => {
					this.videoDialog = true;				
				}, 300)

				if(source) {
					this.analytics('send', {
						hitType: 'event',
						eventCategory: source,
						eventAction: 'click',
						eventLabel: `top billing video`
					});
				}

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'videos',
					eventAction: 'open',
					eventLabel: `top billing`
				});
			},

			stopVideo() {
				let player = document.querySelector('#player');
				player.src = '';
				this.videoDialog = false;

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'videos',
					eventAction: 'close',
					eventLabel: `top billing`
				});
			},

			loadImages(source) {
				this.carouselDialog = true

				if(source) {
					this.analytics('send', {
						hitType: 'event',
						eventCategory: source,
						eventAction: 'click',
						eventLabel: `aerial images`
					});
				}

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'images',
					eventAction: 'open',
					eventLabel: `aerial images`
				});
			},

			closeImages() {
				this.carouselDialog = false

				this.analytics('send', {
					hitType: 'event',
					eventCategory: 'images',
					eventAction: 'close',
					eventLabel: `aerial images`
				});
			},

			analytics(type, data) {
				if(window.ga) {
					ga(type, {
						hitType: data.hitType,
						eventCategory: data.eventCategory,
						eventAction: data.eventAction,
						eventLabel: data.eventLabel
					});
				}
			},

			
		},

		computed: {
			navigationItems() {
				return this.items;
			},

			mobile() {
				return this.$vuetify.breakpoint.mdAndDown
			},

			filteredGalleries() {
				if(this.currentZone) {
					return this.galleries.filter((x) => x.zoneId === this.currentZone.id);
				} else {
					return [];
				}	
			}
		},

		mounted() {
			this.isMobile = this.$vuetify.breakpoint.mdAndDown
			this.start();
			this.currentZone = this.zones.find((x) => x.isDefault);
			// this.$forceUpdate();
		}
	}

</script>

<style>
	.application--wrap {
		min-height: -webkit-fill-available !important;
		min-height: -moz-available !important;		
	}

	#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
  height: 100%
	}

	.title-heading {
		font-family: adorn-garland;
	}

	#iframeHolder {
		width: 100%;
		height: 100%;
	}

	.v-expansion-panel__header {
		padding-left: 2px !important;
		padding-bottom: 2px !important;
		padding-top: 4px !important;
		min-height: 36px !important;
	}

	.v-expansion-panel__container {
		background-color: transparent !important;
	}

	.titleDiv {
		background-color: rgba(0,0,0,0.45) !important;
		/* background-color: #f5f5f5d1 !important; */
		
		position: absolute;
		top:19px;
		height:50px;
		width:20px;
		z-index: 2;
	}

	.agentImage {
		border-top-right-radius: 10px;
	}

	.rightButtons {
		background-color: #7b9169;
		position: absolute;
		left: auto;
		right: 0px;
		bottom: 18px;
		height: 40px;
		border-top-left-radius: 20px;
		border-bottom-left-radius: 2px;
	}

	.title-image {
		height: 90px;
		border-bottom-left-radius: 25px;
    }
	
	.title-text {
		font-family: 'Parisienne', cursive !important;
	}

	.toggleIcon{
		position: absolute;
		left: 50%;
  		margin-left: -8px;
		top:50%;
		margin-top: -8px;
		cursor: pointer;
	}

	.gallery-card {
		/* border-radius: 20% !important; */
		/* border: 1px solid #a79054 */
	}

	.gallery-card-box {
		border-radius: 0 !important;
		border: 0
	}

	.titleRow {
		background-color: rgba(0,0,0,0.75) !important;
		/* background-color: #f5f5f5d1 !important; */
		position: absolute;
		width:338px;
		/* height:50vh; */
		left:21px;
		border-bottom-left-radius: 25px;
    	border-top-right-radius: 25px;
	}

	.gallery-container{
		/* background-color: #f5f5f5d1 !important; */
		background-color: rgba(0,0,0,0.75) !important;
		height: 100%;
		overflow: auto;
	}

	.rowCard {
		border-bottom-left-radius: 25px !important;
		border-top-right-radius: 25px !important;
		height:100%
	}

	.titleDiv {
		background-color: aqua;
		position: absolute;
		top:19px;
		height:50px;
		width:20px
	}

	.font-medium {
		font-size: 32px;
	}

	.expansionHeader {
		color:#2196f3;
	}

	.holder {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.holderMobile {
		width: 100%;
		height: 92vh;
		position: relative;
	}

	#renderCanvas {
		width   : 100%;
		height  : 100%;
		touch-action: none;
	}

	#showcase_iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.bar {
		position: absolute;
		width: 240px;
		height: 250px;
		margin:0 auto;
		perspective: 400px;
		
	}

	.form-5 {
		position: absolute;
		width: 360px;
		height: 580px;
		margin:0 auto;
		left:21px !important;
		top:70px !important;
	}

	/* .v-image__image {
		z-index: 0 !important;
	} */

	.navDrawer {
		background-color: rgba(0,0,0,0.80) !important;
    height: 98% !important;
		right: 8px !important;
		top: 0;
		bottom: 0;
		margin: auto !important;
		border-top-right-radius: 25px;
		border-bottom-left-radius: 25px;
		border-radius: 25px;
	}

	.form-card {
		max-height: 100%;
		max-width: 100%;
		background-color: rgba(0,0,0,0.80) !important;
		transform: rotateY(-10deg);
	}

	.form-card-1 {
		max-height: 100%;
		max-width: 100%;
		border-radius: 0 !important;
		background-color: rgba(0,0,0,0.45) !important;
	}

	.custom-subheader {
		color:#ffffffb3;
	}

	.clubGridMobile {
		height:50vh;
		overflow-y: auto;
	}

	.clubGrid {
		height:50vh;
		width: 50vw !important;
		overflow-y: auto;
	}

	.clickable-style {
		cursor: pointer;
	}

	::-webkit-scrollbar-button{ display: none; height: 13px; border-radius: 0px; background-color: #3e3e3e; } ::-webkit-scrollbar-button:hover{ background-color: #3e3e3e; } ::-webkit-scrollbar-thumb{ background-color: #3e3e3e9a; border-radius: 20px; } ::-webkit-scrollbar-thumb:hover{ background-color: #3e3e3e69; border-radius: 0px; } ::-webkit-scrollbar-track{ background-color: transparent; } ::-webkit-scrollbar-track:hover{ background-color: #3e3e3e96; } ::-webkit-scrollbar{ width: 8px; }
</style>
